import { error99, RetAPI } from '../../Utils/Types'
import { Api } from '../../Utils/api'

export const MenuService = {

    AddImage: async (file?: File): Promise<RetAPI> => {

        const formData = new FormData()
        formData.append("logo", file || '')

        const resp = await Api('Empresa/sendLogo', 'post', formData, true)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
                url_logo: resp.data.url_logo,
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }
    },

    ClearImage: async (): Promise<RetAPI> => {

        const resp = await Api('Util/LimparLogo', 'put')

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }

    },

}
